<div class="container">
    <div class="container-row">
        <div class="back-button-container">
            <button routerLink="/" routerLinkActive="active" (click)="goBackOnce()">back</button>
        </div>
        <div class="container">
            <h1>Bus Tracking</h1>
        </div>
    </div>

    <!-- Develop this div appropriately -->
    <div class="container">
        <agm-map [latitude]='lat' [longitude]='long' [zoom]="zoom" >
            <agm-marker 
                [latitude]="lat" 
                [longitude]="long">    
            </agm-marker>
        </agm-map>
        <div class="Bustracking-banner">
            
            
        </div>
    </div>
        
</div>